<template>
  <div>
    <RecordVideo @saved="addMediaPitch" :media-prop="media">
      <template #header>
        <div class="flex items-center justify-between mb-6">
          <h4 class="font-poppins text-lg font-bold text-blue-800">Record your pitch</h4>

          <div>
            <button @click="$emit('close')" type="button">
              <XIcon class="h-5 text-gray-500" />
            </button>
          </div>
        </div>
      </template>

      <template #footer="{ redo, saving, save }">
        <div class="flex items-center justify-around pt-4" :class="{'opacity-75': saving}">
          <template v-if="saving">
            <div class="flex items-center justify-center py-3">
              <loading-icon class="h-2 text-pink-500"/>
            </div>
          </template>

          <template v-else>
            <button @click.prevent="redo" type="button" class="flex items-center space-x-2 text-pink-500">
              <RedoIcon class="w-4 h-4" />
              <span>Redo</span>
            </button>

            <button
              @click="save"
              type="button" class="bg-indigo-gradiant text-white font-bold px-10 py-3 rounded-full flex items-center justify-center hover:opacity-90 disabled:opacity-50"
            >
              Save Pitch
            </button>
          </template>
        </div>
      </template>
    </RecordVideo>
  </div>
</template>

<script>
  import RedoIcon from '@/components/svgs/RedoIcon'
  import XIcon from '@/components/svgs/XIcon'
  import RecordVideo from '@/components/shared/RecordVideo'

  export default {
    props: {
      media: Object,
    },

    components: {
      RedoIcon,
      XIcon,
      RecordVideo,
    },

    methods: {
      addMediaPitch(media) {
        this.$emit('update-pitch', media)
        this.$emit('close')
      }
    },
  }
</script>
